// extracted by mini-css-extract-plugin
module.exports = {"grid-container":"confirmation_grid-container__tk_Zd"};